import {
    CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_REQUEST,
    CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_SUCCESS,
    CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_FAILURE,

    CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_REQUEST,
    CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_SUCCESS,
    CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_FAILURE,

} from '../../masterDataTypes'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    masterInsideShapes: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_LOAD_MASTER_DATA_INSIDE_SHAPES_FAILURE:
                return []
            default:
                return state
        }
    },
    masterInsideShape: (state = requestState, action) => {
        switch (action.type) {
            case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_REQUEST:
                return state
            case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_LOAD_MASTER_DATA_INSIDE_SHAPE_FAILURE:
                return {}
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/masterDatas/insideShape.js